module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-nav"
  }, [_c('router-link', {
    staticClass: "nav-link home",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/sidebar-logo.png")
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    class: {
      active: _vm.$route.name === 'clusters' || _vm.$route.name === 'locations'
    },
    attrs: {
      "to": {
        name: 'clusters'
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$route.name === 'clusters' || _vm.$route.name === 'locations') ? _c('img', {
    attrs: {
      "src": require("../assets/icon-marker-active.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icon-marker-inactive.png")
    }
  })])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    class: {
      active: _vm.$route.name === 'savedViews'
    },
    attrs: {
      "to": {
        name: 'savedViews'
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$route.name === 'savedViews') ? _c('img', {
    attrs: {
      "src": require("../assets/icon-bookmark-active.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icon-bookmark-inactive.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-link",
    class: {
      active: _vm.$route.name === 'indicators'
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-link"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-user-inactive.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e00c62ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarNav.vue
// module id = 121
// module chunks = 0